import React, { useContext } from "react";
import { css } from "emotion";
import { BuildContext } from "../../../context/BuildSpotlightState";
import { textSizes, boxStyles } from "../../../styles/theme";

const TextContent = () => {
  const { headline, ctaText, secondaryColor } = useContext(BuildContext);

  return (
    <div className={container}>
      <p className="headline" style={{ color: secondaryColor }}>
        {headline}
      </p>
      {ctaText && (
        <div
          className="button"
          style={{ color: secondaryColor, borderColor: secondaryColor }}
        >
          {ctaText}
        </div>
      )}
    </div>
  );
};

export default TextContent;

const container = css`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .headline {
    color: white;
    font-size: ${textSizes.intermediate};
    margin-right: 15px;
    max-width: 200px;
    word-break: break-all;
  }
  .button {
    color: white;
    padding: 3px 12px;
    border-radius: 4px;
    border: 2px solid;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 500;
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    justify-content: center;

    .headline {
      max-width: unset;
    }
  }
`;
